<div class="modal-header">
  <h3>{{ PrimaryTrade && PrimaryTrade.id ? 'Edit' : 'Add' }} Trade</h3>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="close('Cross Click')"
  ></button>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col">
      <form [formGroup]="primaryTradeForm">
        <div class="row g-3">
          <div class="col-6">
            <div class="form-group">
              <label for="name" class="form-label" requiredAsterisk
                >Trade Name</label
              >
              <input
                id="name"
                type="text"
                class="form-control"
                formControlName="name"
              />
            </div>
          </div>

          <div class="col-6">
            <div class="form-group">
              <label for="defaultTier" class="form-label" requiredAsterisk
                >Suggested Tier</label
              >
              <select
                id="defaultTier"
                class="form-select"
                formControlName="defaultTier"
              >
                <option [ngValue]="null" selected disabled>Pick one...</option>
                @for (tier of tradeTiers | keyvalue: keyPairOrder; track tier) {
                  <option [ngValue]="tier.value">
                    {{ tier.key }}
                  </option>
                }
              </select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div class="form-check-group">
              <label for="isProfessional" class="form-check-label"
                >Is professional trade?</label
              >
              <input
                id="isProfessional"
                (ngModelChange)="
                  tradeProfessionalismChange('isProfessional', $event)
                "
                type="checkbox"
                class="form-check-input"
                formControlName="isProfessional"
              />
            </div>
          </div>

          <div class="col">
            <div class="form-check-group">
              <label for="isNonProfessional" class="form-check-label"
                >Is non-professional trade?</label
              >
              <input
                id="isNonProfessional"
                (ngModelChange)="
                  tradeProfessionalismChange('isNonProfessional', $event)
                "
                type="checkbox"
                class="form-check-input"
                formControlName="isNonProfessional"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div class="form-check-group">
              <label
                for="isProfessionalOrNonProfessional"
                class="form-check-label"
                >Is professional or non-professional trade?</label
              >
              <input
                id="isProfessionalOrNonProfessional"
                (ngModelChange)="
                  tradeProfessionalismChange(
                    'isProfessionalOrNonProfessional',
                    $event
                  )
                "
                type="checkbox"
                class="form-check-input"
                formControlName="isProfessionalOrNonProfessional"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div class="form-check-group">
              <label for="isTransporter" class="form-check-label"
                >Transporter?</label
              >
              <input
                id="isTransporter"
                type="checkbox"
                class="form-check-input"
                formControlName="isTransporter"
              />
            </div>
          </div>

          <div class="col">
            <div class="form-check-group">
              <label for="isOnSite" class="form-check-label">On Site?</label>
              <input
                id="isOnSite"
                type="checkbox"
                class="form-check-input"
                formControlName="isOnSite"
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
<div class="modal-footer">
  <div class="row w-100 justify-content-end">
    <div class="col-3">
      <button class="btn btn-danger" (click)="close('Close')">Close</button>
    </div>
    <div class="col-3">
      <button class="btn btn-primary" (click)="save()">Save</button>
    </div>
  </div>
</div>
